// extracted by mini-css-extract-plugin
export default {"wrapper":"_6a0e839b","rating":"_bc57972f"};